
import { supabase } from '@/integrations/supabase/client';

interface AuditLogEntry {
  action: string;
  targetTable: string;
  targetId?: string;
  oldValues?: any;
  newValues?: any;
}

export const logAdminAction = async (entry: AuditLogEntry) => {
  try {
    const { data: currentUser } = await supabase.auth.getUser();
    
    if (!currentUser.user) {
      console.error('[AdminAudit] No authenticated user for audit log');
      return;
    }
    
    const { error } = await supabase
      .from('admin_audit_log')
      .insert({
        admin_id: currentUser.user.id,
        action: entry.action,
        target_table: entry.targetTable,
        target_id: entry.targetId,
        old_values: entry.oldValues,
        new_values: entry.newValues
      });
    
    if (error) {
      console.error('[AdminAudit] Failed to log admin action:', error);
    } else {
      console.log('[AdminAudit] Logged admin action:', entry.action);
    }
  } catch (error) {
    console.error('[AdminAudit] Exception logging admin action:', error);
  }
};

export const getAuditLogs = async (limit: number = 100) => {
  try {
    const { data, error } = await supabase
      .from('admin_audit_log')
      .select('*')
      .order('created_at', { ascending: false })
      .limit(limit);
    
    if (error) {
      console.error('[AdminAudit] Failed to fetch audit logs:', error);
      return [];
    }
    
    return data || [];
  } catch (error) {
    console.error('[AdminAudit] Exception fetching audit logs:', error);
    return [];
  }
};
